export default "__VITE_ASSET__DXDxMxpQ__"